<template>
  <div class="flex flex-col shrink relative">
    <div class="flex shrink-0 flex-row h-2 justify-around">
      <div
        v-for="(_, index) in scaleItemDescriptions"
        :key="index"
        class="triangle hidden md:block"
        :class="[(index != currentSelectedIndex || hideDescriptions) && 'invisible']"
      ></div>
    </div>
    <div
      :class="[
        (currentSelectedIndex == -1 || hideDescriptions) && 'max-h-0',
        currentSelectedIndex != -1 && !hideDescriptions && 'max-h-[200px] p-4',
      ]"
      class="transition-all overflow-y-auto shrink rounded-medium bg-surface-container text-on-surface-variant text-body-small [&_h3]:font-bold [&_h3]:mb-0.5 [&_h3]:mt-3 [&_h3:first-child]:mt-0 [&_h3]:text-body-medium"
      v-html="scaleItemDescriptions[currentSelectedIndex]"
    ></div>

    <div v-if="currentSelectedIndex != -1" class="w-full flex flex-row mt-1 justify-end">
      <BaseTextButton
        v-if="!hideDescriptions"
        size="XS"
        icon="collapse_all"
        class="text-on-surface-variant!"
        @click="hide"
        >{{ $t('feedback.scale-item-description.hide') }}</BaseTextButton
      >
      <BaseTextButton
        v-else
        size="XS"
        icon="expand_all"
        class="text-on-surface-variant!"
        @click="show"
        >{{ $t('feedback.scale-item-description.show') }}</BaseTextButton
      >
    </div>
  </div>
</template>
<script setup lang="ts">
import { useLocalStorage } from '@vueuse/core'
import BaseTextButton from '../../../../core/components/base/button/text-button/BaseTextButton.vue'

interface Props {
  currentSelectedIndex: number
  scaleItemDescriptions: ReadonlyArray<string>
}
defineProps<Props>()

const hideDescriptions = useLocalStorage('hideSclaeItemDescriptions', false)

const hide = () => {
  hideDescriptions.value = true
}
const show = () => {
  hideDescriptions.value = false
}
</script>

<style scoped>
.triangle {
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent var(--color-surface-container) transparent;
  transform: rotate(0deg);
}
</style>
